import {ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal} from '@angular/core';
import {CommonModule} from '@angular/common';

import {DrawingModel, GameModel, GroupRankingModel} from 'shared/models';
import {PlayersUi} from '../players-ui/players-ui';
import {GamesUi} from '../games-ui/games-ui';
import {RankingsUiComponent} from '../rankings-ui/rankings-ui.component';

@Component({
  selector: 'group-ui',
  standalone: true,
  imports: [CommonModule, PlayersUi, GamesUi, RankingsUiComponent],
  templateUrl: './group-ui.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupUi {
  group: InputSignal<number> = input.required<number>();
  drawings: InputSignal<DrawingModel[]> = input.required<DrawingModel[]>();
  games: InputSignal<GameModel[]> = input.required<GameModel[]>();
  groupsRankings: InputSignal<GroupRankingModel[]> = input.required<GroupRankingModel[]>();

  protected groupDrawings: Signal<DrawingModel[]> = computed((): DrawingModel[] => {
    const group: number = this.group();
    const drawings: DrawingModel[] = this.drawings();
    return drawings.filter((model: DrawingModel): boolean => {
      // @TODO: usar enum
      return model.stage === 'groups' && model.group === group;
    });
  });

  protected groupGames: Signal<GameModel[]> = computed((): GameModel[] => {
    const group: number = this.group();
    const games: GameModel[] = this.games();
    return games.filter((model: GameModel): boolean => {
      // @TODO: usar enum
      return model.stage === 'groups' && model.group === group;
    });
  });

  protected groupGroupsRankings: Signal<GroupRankingModel[]> = computed((): GroupRankingModel[] => {
    const group: number = this.group();
    const groupsRankings: GroupRankingModel[] = this.groupsRankings();
    return groupsRankings.filter((model: GroupRankingModel): boolean => {
      return model.group === group;
    });
  });
}
